import { FormattedMessage } from "react-intl";
import chart from "../../../assets/images/ChartGraph.svg";
import StatisticsPercentOverview from "../../common/StatisticsPercentOverview";

const TotalReservation = ({
  title,
  secondTitle,
  description,
  icon,
  count,
  percent,
}: any) => {
  return (
    <div
      className={`flex flex-col md:flex-row justify-between my-2 rounded-lg w-full`}
    >
      <div className=" text-center md:text-start flex flex-col gap-3">
        <p className="text-[#75757E] ">{icon}</p>
        <p className=" text-[#75757E]">{secondTitle}</p>
        <h2 className="text-[20px]  font-medium flex items-center gap-2">
          <span className="">{count}</span>
          {title}
        </h2>
        <StatisticsPercentOverview percent={percent} />
      </div>
      <div className="flex align-bottom mt-3 md:mt-0">
        <img className="object-cover w-full md:ml-10" src={chart} alt="" />
      </div>
    </div>
  );
};

export default TotalReservation;
